module.exports = __webpack_public_path__ + "img/add-new.4c5fa96f.svg";